import React, { useEffect } from "react";
import { motion } from "framer-motion";
import Hero from "../components/Hero";
import CompanyProfile from "../components/Projects/CompanyProfile";
import Services from "../components/Services";
import Portfolio from "../components/Portfolio";
import About from "../components/About";
import Contact from "../components/Contact";

const Home = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const pageVariants = {
    initial: { opacity: 0, y: 20 },
    in: { opacity: 1, y: 0 },
    out: { opacity: 0, y: -20 }
  };

  const pageTransition = {
    type: "tween",
    ease: "anticipate",
    duration: 0.5
  };

  return (
    <motion.div
      initial="initial"
      animate="in"
      exit="out"
      variants={pageVariants}
      transition={pageTransition}
    >
      <CompanyProfile/>
      <Hero />
      <Services />
      <Portfolio />
      <About />
      <Contact />
    </motion.div>
  );
};

export default Home;